/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_AuditInputs */

const en_mk_mx_audit = /** @type {(inputs: Mk_Mx_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail of sensitive actions`)
};

const id_mk_mx_audit = /** @type {(inputs: Mk_Mx_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan audit aksi sensitif`)
};

/**
* | output |
* | --- |
* | "Audit trail of sensitive actions" |
*
* @param {Mk_Mx_AuditInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_audit = /** @type {((inputs?: Mk_Mx_AuditInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_AuditInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_audit(inputs)
	return en_mk_mx_audit(inputs)
});